import React from 'react';

export function Error404() {
    return (
        <div className="container">
            <div className="row">
                <div className="col text-center">
                    <div className="h4">Sorry, we couldn&apos;t find your page!</div>
                </div>
            </div>
        </div>
    );
}
